import { DEFAULT_COLOR } from '@features/invoicingSettings/constants/defaultColor'
import { DEFAULT_FONT } from '@features/invoicingSettings/constants/defaultFont'
import { useUpdateZervantDocumentTemplateSettings } from '@features/invoicingSettings/hooks/useUpdateZervantDocumentTemplateSettings'

import { InvoiceSettingsForm } from '../types/invoiceSettingsForm'
import { getTemplateAreasPayload } from '../utils/invoiceSettingsPayload/getTemplateAreasPayload'

export const useUpdateInvoiceTemplateSettings = () => {
  const { update, isProcessing } = useUpdateZervantDocumentTemplateSettings()

  const updateInvoiceTemplateSettings = (formData: InvoiceSettingsForm) => {
    if (isProcessing) {
      return
    }

    update({
      areas: getTemplateAreasPayload(formData),
      color: {
        text: formData.templateColor || DEFAULT_COLOR,
      },
      font: formData.templateFont || DEFAULT_FONT,
    })
  }

  return { update: updateInvoiceTemplateSettings, isProcessing }
}
